import React, { Fragment, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import swal from "sweetalert";
import MetaTag from "../layout/MetaTag";
import "./sports.css";
import { addEllipsis } from "../utils/textRapUtils";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CloseIcon from "@mui/icons-material/Close";
import Logo2 from "../images/not_found_product.png";
import { directBuyAction } from "../redux/actions/directBuyAction";

const safeText = (value, fallback = "") => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === "string" || typeof value === "number")
    return String(value);
  return fallback;
};

const safeNumber = (value, fallback = 0) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
};

const safeArray = (value) => (Array.isArray(value) ? value : []);

const RatingStars = ({ value = 0 }) => {
  const rating = Math.max(0, Math.min(5, Math.round(safeNumber(value))));

  return (
    <div
      className="sports-rating-stars"
      aria-label={`${rating} out of 5 rating`}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={
            star <= rating ? "sports-star-active" : "sports-star-muted"
          }
        >
          ★
        </span>
      ))}
    </div>
  );
};

const NEUTRAL_PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Crect width='400' height='400' fill='%23f4f4f5'/%3E%3Ccircle cx='200' cy='175' r='36' fill='%23e4e4e7'/%3E%3Cpath d='M155 240l30-38 22 26 33-42 35 54H155z' fill='%23d4d4d8'/%3E%3Ctext x='200' y='278' font-family='system-ui, sans-serif' font-size='13' font-weight='700' fill='%2371717a' text-anchor='middle'%3EIMSHOP%3C/text%3E%3C/svg%3E";

const getProductImage = (product, fallbackImage) => {
  const selectedImage = safeText(fallbackImage);
  const mainImage = safeText(product?.mainImage?.[0]?.imageurl);
  const galleryImage = safeText(product?.image?.[0]?.imageurl);
  return selectedImage || mainImage || galleryImage || NEUTRAL_PLACEHOLDER;
};

function Sportspage({ currentItems = [] }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);

  const [currentImage, setCurrentImage] = useState("");
  const [productId, setProductId] = useState("");
  const [buyNowButtonClick, setBuyNowButtonClick] = useState(false);
  const [seletedProductId, setSelectedProductId] = useState();
  const [selectBox, setSelectBox] = useState("");
  const [colour, setColour] = useState("");
  const [size, setSize] = useState("");

  const productHandler = (id) => {
    const product = currentItems.find((p) => p._id === id);
    if (product) history.push(`/product/${product.slug || product._id}`);
  };

  const imageSelectHandler = (productUrl, productId) => {
    setCurrentImage(productUrl);
    setProductId(productId);
  };

  const buyNowHandler = (id) => {
    if (!id) {
      return swal({
        title: "Validation Info",
        text: "Invalid..!!",
        icon: "info",
      });
    }

    setSelectedProductId(id);
    setBuyNowButtonClick(true);
  };

  const bestSellerBuyNowHanlder = (e) => {
    e.preventDefault();

    if (!size || !colour) {
      return swal({
        title: "Validation Error",
        text: "Please Select Colour and Size..!!",
        icon: "info",
      });
    }

    if (!selectBox) {
      return swal({
        title: "Validation Error",
        text: "Please Select Box !!",
        icon: "info",
      });
    }

    const quantity = 1;
    dispatch(
      directBuyAction(seletedProductId, quantity, size, colour, selectBox)
    );

    if (!isAuthenticated) {
      swal({
        title: "Validation Error",
        text: "Please Login..!!",
        icon: "info",
      });
    }

    history.push("/Login?redirect=/Checkout/directbuy");
  };

  const closeBestSellerBuyNowButton = () => {
    setBuyNowButtonClick(false);
    setSelectedProductId("");
  };

  return (
    <Fragment>
      {currentItems.length === 0 ? (
        <Fragment>
          <MetaTag title={"Sorry We Didnt found any Shoes !!"} />
          <div className="not-found-container">
            <img src={Logo2} alt="No products found" />
            <h4>No sneakers found</h4>
            <p>Try a different search, category, collection, or price range.</p>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          {currentItems.map((product, index) => {
            const selectedImage = product._id === productId ? currentImage : "";
            const displayImage = getProductImage(product, selectedImage);
            const productName = safeText(product?.name, "Product");
            const productTag = safeText(product?.tag, "Sneakers");
            const productBrand = safeText(
              product?.brandName || product?.category,
              "IM Online"
            );
            const productPrice = safeNumber(product?.price);
            const discountPrice = safeNumber(product?.discountPrice);
            const ratings = safeNumber(product?.ratings);
            const productStock = safeNumber(product?.productStock);
            const deliveryLabel = product?.isdeliveryFree
              ? "Free delivery"
              : "Delivery available";

            return (
              <article
                className="Sports-prodcuts-div"
                key={product._id || index}
              >
                <Helmet>
                  <script type="application/ld+json">
                    {JSON.stringify({
                      "@context": "https://schema.org",
                      "@type": "Product",
                      name: productName,
                      image: displayImage,
                      description: addEllipsis(
                        safeText(product?.discription),
                        150
                      ),
                      brand: {
                        "@type": "Brand",
                        name: productBrand,
                      },
                      sku: product._id,
                      offers: {
                        "@type": "Offer",
                        url: `https://imonline.shop/product/${
                          product.slug || product._id
                        }`,
                        priceCurrency: "INR",
                        price:
                          product.discountActive === true
                            ? productPrice - discountPrice
                            : productPrice,
                        priceValidUntil: new Date(
                          new Date().setFullYear(new Date().getFullYear() + 1)
                        )
                          .toISOString()
                          .split("T")[0], // Valid for 1 year
                        availability:
                          productStock > 0
                            ? "https://schema.org/InStock"
                            : "https://schema.org/OutOfStock",
                        itemCondition: "https://schema.org/NewCondition",
                      },
                      aggregateRating: {
                        "@type": "AggregateRating",
                        ratingValue: ratings,
                        reviewCount: safeNumber(product?.numOfReviews, 0),
                      },
                    })}
                  </script>
                  {/* Open Graph Meta Tags for Social Sharing */}
                  <meta
                    property="og:title"
                    content={`${productName} | ${productBrand}`}
                  />
                  <meta
                    property="og:description"
                    content={addEllipsis(safeText(product?.discription), 150)}
                  />
                  <meta property="og:image" content={displayImage} />
                  <meta
                    property="og:url"
                    content={`https://imonline.shop/product/${
                      product.slug || product._id
                    }`}
                  />
                  <meta property="og:type" content="product" />
                  <meta property="product:brand" content={productBrand} />
                  <meta
                    property="product:price:amount"
                    content={
                      product.discountActive === true
                        ? productPrice - discountPrice
                        : productPrice
                    }
                  />
                  <meta property="product:price:currency" content="INR" />
                  <meta
                    property="product:availability"
                    content={productStock > 0 ? "instock" : "oos"}
                  />
                  {/* Twitter Card Meta Tags */}
                  <meta name="twitter:card" content="summary_large_image" />
                  <meta
                    name="twitter:title"
                    content={`${productName} | ${productBrand}`}
                  />
                  <meta
                    name="twitter:description"
                    content={addEllipsis(safeText(product?.discription), 150)}
                  />
                  <meta name="twitter:image" content={displayImage} />
                </Helmet>
                <button
                  className="Sports-images-div"
                  type="button"
                  onClick={() => productHandler(product._id)}
                >
                  {displayImage ? (
                    <img
                      src={displayImage}
                      alt={productName}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = NEUTRAL_PLACEHOLDER;
                      }}
                    />
                  ) : (
                    <span className="sports-image-placeholder">No Image</span>
                  )}
                </button>

                <div className="sports-product-slide-div">
                  {safeArray(product.image).map((newImage, imageIndex) => (
                    <button
                      type="button"
                      key={newImage.public_id || imageIndex}
                      onClick={() =>
                        imageSelectHandler(
                          safeText(newImage.imageurl),
                          product._id
                        )
                      }
                    >
                      <img
                        src={safeText(newImage.imageurl)}
                        alt={`${productName} - view ${imageIndex + 1}`}
                      />
                    </button>
                  ))}
                </div>

                {product.discountActive === true && (
                  <p className="sports-product-discount">
                    {Math.round(
                      (discountPrice / (productPrice + discountPrice)) * 100
                    )}
                    % off
                  </p>
                )}

                <div className="sports-card-body">
                  <div className="sports-card-kicker">
                    <p className="sports-product-tag">{productTag}</p>
                    <p className="sports-product-brand">{productBrand}</p>
                  </div>

                  <div className="Sports-Product-title">
                    <h6>
                      <Link
                        to={`/product/${product.slug || product._id}`}
                      >
                        {addEllipsis(productName)}
                      </Link>
                    </h6>
                  </div>

                  <div className="sports-card-price-rating">
                    <div className="sports-product-main-price-container">
                      {product.discountActive === true ? (
                        <div className="Sports-product-price">
                          <p className="sports-product-price-after-discount">
                            Rs {productPrice - discountPrice}
                          </p>
                          <p>
                            <s className="sports-product-price-cross">
                              Rs {productPrice}
                            </s>
                          </p>
                        </div>
                      ) : (
                        <div className="Sports-product-price">
                          <p>Rs {productPrice}</p>
                        </div>
                      )}
                    </div>

                    <div className="bestSeller-Star">
                      <RatingStars value={ratings} />
                    </div>
                  </div>

                  <div className="sports-product-meta-row">
                    <span>{deliveryLabel}</span>
                    <span>
                      {productStock > 0
                        ? `${productStock} left`
                        : "Limited stock"}
                    </span>
                  </div>

                  <div className="Sports-product-btns">
                    <Link
                      to={`/product/${product.slug || product._id}`}
                      className="sports-card-details-link"
                    >
                      Details
                    </Link>
                    <button
                      onClick={() => buyNowHandler(product._id)}
                      className="Sports-product-buy-btn"
                    >
                      <ShoppingCartIcon />
                      <span>Add</span>
                    </button>
                  </div>
                </div>

                {buyNowButtonClick !== false &&
                seletedProductId === product._id ? (
                  <div className="buy-now-main-container">
                    <div className="buy-now-second-conatiner-close-div">
                      <button
                        type="button"
                        onClick={closeBestSellerBuyNowButton}
                      >
                        {" "}
                        <CloseIcon />{" "}
                      </button>
                    </div>
                    <div className="buy-now-second-container">
                      <div className="buy-now-third-container">
                        <h2 className="heading-for-buy-now">Select Options</h2>
                      </div>
                      <form onSubmit={bestSellerBuyNowHanlder}>
                        <div className="buy-now-size-detail-div">
                          <span>
                            <label>Sizes</label>
                            <select onChange={(e) => setSize(e.target.value)}>
                              <option value="">Select Size</option>
                              {safeArray(product.sizeOfShoes).map(
                                (sizes, index) => (
                                  <option value={safeText(sizes)} key={index}>
                                    {safeText(sizes)}
                                  </option>
                                )
                              )}
                            </select>
                          </span>
                        </div>
                        <div className="buy-now-colour-detail-div">
                          <span>
                            <label>Colours</label>
                            <select onChange={(e) => setColour(e.target.value)}>
                              <option value="">Select Colour</option>
                              {safeArray(product.colorOfShoes).map(
                                (category, index) => (
                                  <option
                                    value={safeText(category)}
                                    key={index}
                                  >
                                    {safeText(category)}
                                  </option>
                                )
                              )}
                            </select>
                          </span>
                        </div>
                        <div className="buy-now-colour-detail-div">
                          <span>
                            <label>Box Type</label>
                            <select
                              onChange={(e) => setSelectBox(e.target.value)}
                            >
                              <option value="">Select Packaging Type</option>
                              <option value="0">Default-Packing</option>
                              <option value="50">Simple-Box 50₹</option>
                              <option value="150">Original-Box 150₹</option>
                            </select>
                          </span>
                        </div>
                        <div className="buy-now-container-btn-div">
                          <input type="submit" value="Buy Now" />
                        </div>
                      </form>
                    </div>
                  </div>
                ) : null}
              </article>
            );
          })}
        </Fragment>
      )}
    </Fragment>
  );
}

export default Sportspage;
